import type { RoleTypeOperationTypeDto } from "common/models/api/models/RoleTypeOperationTypeDto";
import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export default function useUpdateOperationTypes(
    options?: UseCustomMutationOptions<RoleTypeOperationTypeDto[], unknown, RoleTypeOperationTypeDto[]>,
): UseMutationResult<RoleTypeOperationTypeDto[], unknown, RoleTypeOperationTypeDto[]> {
    return useMutation(async (body: RoleTypeOperationTypeDto[]) => {
        const res = await releaseStrategyApi.updateOperationTypes(body);
        return res.data;
    }, options);
}
